export const SAVE_BUTTON_CLICK = 'APP_FORM.SAVE_BUTTON_CLICK';
export const OPEN_CHILD_FORM_ON_NEW_PANEL = 'APP_FORM.OPEN_CHILD_FORM_ON_NEW_PANEL';
export const GET_FORMVIEWER_DATAS = 'APP_FORM.GET_FORMVIEWER_DATAS';
export const WORKFLOW_EVENT_CLICK = 'APP_FORM.WORKFLOW_EVENT_CLICK';
